/* eslint-disable */
import OS, {addScript, serializeUrlParams } from './os'
import winxinShare from './weixin'

const shareInfo = {
    title: '你的小伙伴请你定义流行',
    link: window.location.href,
    desc: '糟糕，是心动的感觉！这首歌太好听了，忍不住分享给你，喜欢的话就点个赞吧^_^',
    imgUrl: 'https://yobang.tencentmusic.com/share.png'
};

export default (shareInfo) => {
    // 微信被动分享
    if (OS.isWeixin) {
        winxinShare(shareInfo);
    }
    // QQ的被动分享
    let isQQ = window.mqq && window.mqq.data && window.mqq.data.setShareInfo
    if (isQQ) {
        mqq.data.setShareInfo({
            title: shareInfo.title,
            desc: shareInfo.desc,
            image_url: shareInfo.imgUrl,
            share_url: shareInfo.link
        }, function(res) {
            console.log(res)
        });
    }
    // QQ音乐端内被动分享
    if (OS.isQQMusic) {
        M.musicReady(function() {
            M.client.open("ui", "setActionBtn", {
                type: 'icon',
                content: "share"
            }, code => {
                M.client.open('other', 'callShareWeb', {
                    imgUrl: shareInfo.imgUrl,
                    link: shareInfo.link,
                    title: shareInfo.title,
                    desc: shareInfo.desc,
                    wxTimelineTitle: shareInfo.title,
                    reportTag: 'gufengzhengji'
                })
            })
        });
    }
    // 酷我并没有被动分享

    // 酷狗并没有被动分享

    // 微博被动分享
    
}

// 微信端内主动分享
export const webchatShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    winxinShare(options)
    document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', `<div class="webchat-qrcode" onClick="this.remove()"><div class="pic"></div></div>`);
}

// QQ端内主动分享
export const qqShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options)
    let mqq = window.mqq
    if (mqq && mqq.data && mqq.data.setShareInfo) {
        mqq.data.setShareInfo({
            title: options.title,
            desc: options.desc,
            image_url: options.imgUrl,
            share_url: options.link
        }, function(res) {
            console.log(res)
        });
        mqq.ui.showShareMenu()
    }
}

// 微博端内主动分享
export const weiboShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    console.log('weibo')
}

// qq音乐端内主动分享
export const qqyinShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    M.musicReady(function() {
        M.client.open('other', 'callShareWeb', {
            imgUrl: options.imgUrl,
            link: options.link,
            title: options.title,
            desc: options.desc,
            wxTimelineTitle: options.title,
            reportTag: 'gufengzhengji'
        }, function() {})
    })
}

// 酷我端内主动分享
export const kuwoShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    window.kuwoApi && window.kuwoApi.share({
        url: options.link,
        weibo: options.title,
        qqspace: options.desc,
        qqspaceTitle: options.title,
        qqfriend: options.desc,
        qqfriendTitle: options.title,
        wxmsg: options.title,
        wxdes: options.desc,
        needconfirm: '0',
        callback: function(res) {
          console.log('shareRes', res);
        }
    });
}

// 酷狗端内主动分享
export const kugouShare = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    window.KgMobileCall && window.KgMobileCall.share({
      "type": 3,
      "shareData": {
        "linkUrl": options.link,
        "picUrl": options.imgUrl,
        "content": options.desc,
        "title": options.title
      }
    });
}

// 微信主动分享-弹二维码(网页)
export const shareWebchatWeb = (options = {}) => {
    document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', `<div class="webchat-qrcode" onClick="this.remove()"><div class="qrcode"></div></div>`);
}

// QQ主动分享(网页)
export const shareQQWeb = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    // const url_scheme = '//share/to_fri?src_type=web&version=1&file_type=news&share_id=1103437993&title=' + window.btoa(options.title) + '&thirdAppDisplayName=5o6M5LiK55CG5bel5aSn&url=' + window.btoa(options.link) + '&description=' + window.btoa(options.desc);
    // window.location.assign('mqqapi:' + url_scheme);
    // setTimeout(() => {
    //     window.location.assign('timapi:' + url_scheme);
    // }, 1500);
    let params = {
        url: options.link,
        showcount: '0', /*是否显示分享总数,显示：'1'，不显示：'0' */
        desc: options.desc, /*默认分享理由(可选)*/
        summary: options.desc, /*分享摘要(可选)*/
        title: options.title, /*分享标题(可选)*/
        site: '由你音乐榜', /*分享来源 如：腾讯网(可选)*/
        pics: options.imgUrl, /*分享图片的路径(可选)*/
        style: '101',
        width: 98,
        height: 22
    };
    // 分享到QQ
    window.location.href = `//connect.qq.com/widget/shareqq/index.html?${serializeUrlParams(params)}`;
}

// QQ空间主动分享(网页)
export const shareQQzoneWeb = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    const share = {
        title: options.title,
        desc: options.desc,
        image_url: [options.imgUrl],
        share_url: options.link
    };
    let image_urls = share.image_url.map(function(image) {
        return encodeURIComponent(image);
    });
    window.location.replace('//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(share.share_url) + '&site=由你音乐榜&title=' + share.title + '&pics=' + image_urls.join('|') + '&summary=' + share.desc);
}

// 微博主动分享(网页)
export const shareSinaWeb = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    window.location.href = `//service.weibo.com/share/share.php?appkey=&title=${options.title}&searchPic=false&pic=${options.imgUrl}&url=${shareInfo.link}&style=simple`;
}

// UC浏览器端内分享
export const shareUcbrower = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    if (typeof ucbrowser === 'object' || typeof ucweb === 'object') {
        const isiOS = /(iphone|ipad|ipod)/i.test(navigator.userAgent);
        if (isiOS) {
            if (ucbrowser.web_shareEX) {
                ucbrowser.web_shareEX(
                    JSON.stringify({
                        title: options.title,
                        content: options.desc,
                        sourceUrl: options.link,
                        imageUrl: options.imgUrl,
                        source: '由你音乐榜',
                        target: undefined
                    })
                )
            } else {
                ucbrowser.web_share(options.title, options.desc, options.link, undefined, '', '由你音乐榜', options.imgUrl);
            }
        } else {
            console.log(options.imgUrl)
            //  shareInfo = [ config.title, config.desc, config.url, platform, '', '', '' ];
            // WechatTimeline
            ucweb.startRequest("shell.page_share", [options.title, options.desc, options.link, '', '', '', ''])
        }
    }
}

// QQ浏览器端内分享
export const shareQQbrower = (options = {}) => {
    options = Object.assign({}, shareInfo, options);
    console.log(options.imgUrl)
    if (browser && browser.app) {
        browser.app.share({
            title: options.title,
            description: options.desc,
            url: options.link,
            img_url: options.imgUrl,
            from: '',
            to_app: undefined
        });
    }
}
